import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { UserRoleResponse } from '@app/interfaces/auth';
import { AddUserModel } from '@app/modules/system-settings/user-management/users/models/add-user.model';
import { IListService } from '@app/services';
import { OpenIdUser } from '../models';

@Injectable()
export class UserService implements IListService {
	endpointBase = '/api/user';
	// Temporary base URL until we completely migrate to the code-first controller
	endpointBaseCF = '/api/user-cf';

	constructor(private readonly http: HttpClient) {}

	// IListService implementation
	getList(): Observable<any> {
		return this.list({});
	}

	// IListService implementation
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	bulkDeleteEntities?(ids: number[] | string[]): Observable<any> {
		return EMPTY;
	}

	getUserRole(id: string): Observable<UserRoleResponse> {
		return this.http.get<UserRoleResponse>(`${this.endpointBase}/roles`, { params: { id } });
	}

	list(userFilterModel: any): Observable<any> {
		return this.http.post(`${this.endpointBase}/list`, userFilterModel);
	}

	/**
	 * getUsersToAssignAccountList: Retrieves a list of users that are assigned or available for assignment to a specific account.
	 * @param accountId
	 * @returns
	 */
	public getUsersToAssignAccountList(accountId: number): Observable<any> {
		const params = new HttpParams().set('accountId', accountId.toString());
		return this.http.get(`${this.endpointBaseCF}/users-account-assignment-list`, { params });
	}

	public usersAssignToAccount(accountId: number, userIds: string[]): Observable<any> {
		return this.http.post(`${this.endpointBaseCF}/users-assign-account`, { AccountId: accountId, UserIds: userIds });
	}

	getUser(Id: string): Observable<any> {
		return this.http.get(this.endpointBaseCF, { params: { Id } });
	}

	getOpenIdUser(email: string): Observable<OpenIdUser> {
		return this.http.get<OpenIdUser>(`${this.endpointBaseCF}/openid-user`, { params: { email } });
	}

	// EndpointEnum: UpdateUser
	update(user: any): Observable<any> {
		return this.http.post(this.endpointBaseCF, user);
	}

	// EndpointEnum: UpdateUser
	deleteEntity(userId: string): Observable<any> {
		return this.http.delete(`${this.endpointBaseCF}/deleteUser`, { params: { userId } });
	}

	// EndpointEnum: UpdateUser
	updateUserClaims(userId: string, claimType: string, claimValues: string[]): Observable<any> {
		return this.http.post(`${this.endpointBase}/userClaims`, {
			UserId: userId,
			ClaimType: claimType,
			ClaimValues: claimValues,
		});
	}

	// EndpointEnum: UpdateUser
	add(user: AddUserModel): Observable<any> {
		return this.http.put(this.endpointBaseCF, user);
	}

	resetUser(email: string): Observable<any> {
		return this.http.post(`${this.endpointBaseCF}/reset-user`, JSON.stringify(email), {
			headers: { 'Content-Type': 'application/json' },
		});
	}
}
